import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Modal, SelectInput, SecondaryButton } from '@PipelineDeals/shared-react-components'
import { getVisibleActiveUsers } from 'VisibleUsers/selectors'

const ESignaturesSelectUser = ({ isOpen, onClose, onSelectUser, overrideSelectUserData }) => {
  const { t } = useTranslation()
  const accountUsers = useSelector(getVisibleActiveUsers)
  const [userOptions, setUserOptions] = useState([])

  useEffect(() => {
    const sourceOfTruth = overrideSelectUserData || accountUsers

    const options = sourceOfTruth.map(({ id, full_name, email }) => ({
      value: id,
      label: full_name,
      email: email
    }))
    setUserOptions(options)
  }, [accountUsers, overrideSelectUserData])

  const handleUserChange = (option) => {
    onSelectUser(option)
  }

  return (
    <Modal
      title={t('eSignatures.selectUser.title')}
      isOpen={isOpen}
      onClose={onClose}
      footerTrailingContent={(
        <>
          <SecondaryButton content={t('common.buttons.close')} onClick={onClose} />
        </>
      )}
      contentStyles={{
        bottom: 'auto',
        left: 'auto',
        right: 'auto',
        top: 'auto',
        width: '400px'
      }}
    >
      <SelectInput
        label={t('eSignatures.selectUser.searchForUser')}
        placeholder={t('eSignatures.selectUser.typeUserName')}
        onChange={handleUserChange}
        options={userOptions}
        searchable
      />
    </Modal>
  )
}

ESignaturesSelectUser.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectUser: PropTypes.func.isRequired,
  overrideSelectUserData: PropTypes.array
}

export default ESignaturesSelectUser
